<template>
    <div class="row position-relative">
        <button type="button" class="position-absolute btn btn-link p-0"
            style="top: -12px; right: 20px; z-index: 1"
            :title="$t('delete')"
            v-if="idx > 0"
            @click="handleRemove(address)"
        >
            <font-awesome-icon icon="times" />
        </button>

        <div class="col-12 col-md-6" v-if="isAirport">
            <div class="mb-1 is-required">
                {{ $t('airport') }}:
            </div>

            <div>
                <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="address.street"
                >
            </div>
        </div>

        <template v-if="!isAirport">
            <div :class="showFlightNumber ? 'col-12 col-md-6' : 'col-12 col-md-9'">
                <div class="mb-1 is-required">
                    {{ $t('street') }}:
                </div>

                <input
                    class="form-control"
                    required
                    :value="address.street"
                    :disabled="lockAddress"
                    @input="onInput($event, 'street')"
                >
            </div>

            <div class="col-12 col-md-3">
                <div class="mb-1 is-required">
                    {{ $t('zip') }}:
                </div>

                <input
                    class="form-control"
                    required
                    maxlength="10"
                    :value="address.zip"
                    :disabled="lockAddress"
                    @input="onInput($event, 'zip')"
                >
            </div>
        </template>

        <div class="col-12 col-md-6" v-if="isAirport">
            <div class="mb-1">
                {{ $t('flight_number') }}:
            </div>

            <template v-if="showFlightNumber">
                <input
                    class="form-control"
                    :value="address.flight_number"
                    :disabled="lockAddress"
                    @input="onInput($event, 'flight_number')"
                >
            </template>

            <template v-if="showFlightNumberReturn">
                <input
                    class="form-control"
                    :value="address.flight_number_return"
                    @input="onInput($event, 'flight_number_return')"
                >
            </template>
        </div>

        <div class="col-12 pt-2">
            <div class="mb-1">
                {{ $t('comment') }}:
            </div>

            <input
                class="form-control"
                :value="address.return_comments"
                :placeholder="isAirport ? $t(type === 'pickup' || type === 'return_pickup' ? 'taxi.provide_flight_arrival_time' : 'taxi.provide_flight_time') : ''"
                v-if="commentsForReturn"
                @input="onInput($event, 'return_comments')"
            >

            <input
                class="form-control"
                :value="address.comments"
                :placeholder="isAirport ? $t(type === 'pickup' || type === 'return_pickup' ? 'taxi.provide_flight_arrival_time' : 'taxi.provide_flight_time') : ''"
                v-else
                @input="onInput($event, 'comments')"
            >
        </div>

        <div class="col-12 pt-4 pickup-address-info-text" v-if="infoText">
            <h4 class="mb-3">
                {{ $t('taxi.pages.addresses.pickup_address_info_title') }}
            </h4>
            <div v-html="$t('taxi.pages.addresses.pickup_address_info_desc')" />
        </div>
    </div>
</template>
<style lang="scss">
    .pickup-address-info-text {
        h4{
            color: #ba1913;
            font-size: 18px;
        }
        p{
            font-size: 14px;
        }
    }
</style>
<script>
    import { updateClone } from '@utilities/object';

    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },

            idx: {
                type: Number,
                required: true,
            },

            isAirport: {
                type: Boolean,
                required: true,
            },

            airportName: {
                type: String,
                default: '',
            },

            lockAddress: {
                type: Boolean,
                default: false,
            },

            showFlightNumber: {
                type: Boolean,
                default: true,
            },

            showFlightNumberReturn: {
                type: Boolean,
                default: false,
            },

            commentsForReturn: {
                type: Boolean,
                default: false,
            },

            type: {
                type: String,
                required: true,
            },

            infoText: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        methods: {
            handleRemove(address) {
                if (!confirm(this.$t('taxi.pages.addresses.address_remove_confirm'))) {
                    return;
                }

                this.$emit('remove', address);
            },

            onInput(event, field) {
                const data = updateClone(this.address, field, event.target.value);

                this.$emit('update', data);
            },
        },
    };
</script>
